import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./helpers/authConfig";
import UserContextProvider from "./hooks/UserContext";
import { ToastProvider } from "./hooks/ToastContext";
// import { ClearBrowserCacheBoundary } from "react-clear-browser-cache";

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserContextProvider>
      <MsalProvider instance={msalInstance}>
        <ToastProvider>
          <App />
        </ToastProvider>
      </MsalProvider>
    </UserContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
